<template>
  <div>
    <div class="flex-grow-1 d-flex justify-content-between align-items-center mb-3">
      <div class="text-large bolder">Updates for you</div>
      <activity-type-filter
        class="activity-filter"
        :selected="eventType"
        @change="onEventTypeChange"
      />
    </div>
    <activity-feed
      :filter-details="filterDetails"
      class="activity-feed"
      :org-id="orgId"
      :sub-org-id="subOrgId"
    />
  </div>
</template>

<script>
import { trackEvent } from '@/analytics'
import ActivityFeed from '@/components/activity/ActivityFeed.vue'
import ActivityTypeFilter from '@/components/activity/ActivityTypeFilter.vue'
import { ACTIVITY_TYPE_ANALYTICS_NAME } from '@/constants/activity'
import { EVENT_ACTION, EVENT_CATEGORY } from '@/constants/analytics'

export default {
  name: 'UserUpdates',
  props: ['orgId', 'subOrgId'],
  components: { ActivityFeed, ActivityTypeFilter },
  data() {
    return {
      eventType: null,
      filterDetails: null
    }
  },
  computed: {},
  methods: {
    onEventTypeChange(eventType) {
      this.eventType = eventType.id
      this.filterDetails = {
        filterName: eventType.filterName,
        filterValue: eventType.filterValue
      }
      trackEvent(
        EVENT_CATEGORY.PREFERENCE,
        EVENT_ACTION.ACTIVITY_FILTER_YOUR_WORK,
        ACTIVITY_TYPE_ANALYTICS_NAME[eventType.id]
      )
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
